<template>
  <section id="paypal-confirm">
    <div class="container">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div align="center">
            <div class="pending-circle">
              <i class="fa fa-paypal icon-pending"></i>
            </div>
            <h2 class="page-title">
              {{$t("thankYou.paypal.title")}}
            </h2>
            <p class="page-text mt-30">
              {{$t("thankYou.paypal.message")}}
            </p>
            <p class="page-text mt-30">
              {{$t("thankYou.paypal.legend")}}
            </p>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" name="form-paypal" target="_top" class="mt-30">
              <div class="row d-none">
                <input name="cmd" value="_xclick" />
                <input name="upload" value="1" />
                <input name="business" value="javier2digital@gmail.com" />
                <input name="item_name" value="Productos 2digital" />
                <input name="shopping_url" value="https://2digital.chuspic.com" />
                <input name="return" value="https://2digital.chuspic.com" />
                <input name="cancel_return" value="https://2digital.chuspic.com" />
                <input name="rm" value="2">
                <input name="currency_code" value="MXN" />
                <input name="cbt" value="Regresar al sitio de 2digital" />
                <input name="item_number" :value="order.order_number" />
                <input name="amount" :value="order.total" />
              </div>
              <input alt="PayPal. La forma rápida y segura de pagar en línea." name="submit" src="http://www.paypalobjects.com/es_XC/MX/i/btn/btn_buynowCC_LG.gif" type="image" border="0" />
              <img alt="" src="http://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1" border="0" />
            </form>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Checkout.PaypalConfirm",
  data() {
    return {
      order: {}
    };
  },
  mounted() {
    if(this.$route == undefined || !this.$route.params.hasOwnProperty("order")) {
      this.$router.push({name: "Home"})
    } else {
      this.order = this.$route.params.order
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  #paypal-confirm {
    margin: 100px 0;
  }

  .pending-circle {
    width: 104px;
    height: 104px;
    border-radius: 50px;
    text-align: center;
    background: rgba(160, 218, 255, 0.2);

    .icon-pending {
      text-align: center;
      font-size: 55px;
      margin-top: 24px;
      color: rgba(86, 190, 255, 1);
    }
  }
</style>
